export const LOAN_ADMIN_RATE = 0.08;
export const LOAN_MIN_AMOUNT = 500000;
export const LOAN_MAX_AMOUNT = 10000000;
export const LOAN_TENORS = [2, 4, 6, 8, 10];

export function calculateLoanInstallment(nominal, tenor) {
  const principal = Math.max(0, parseInt(nominal, 10) || 0);
  const months = Math.max(0, parseInt(tenor, 10) || 0);
  const totalAdministration = parseInt(principal * LOAN_ADMIN_RATE, 10) || 0;
  const monthlyPrincipal = months ? Math.round(principal / months) : 0;
  const monthlyAdministration = months
    ? Math.round(totalAdministration / months)
    : 0;

  return {
    principal,
    months,
    totalAdministration,
    monthlyPrincipal,
    monthlyAdministration,
    monthlyInstallment: monthlyPrincipal + monthlyAdministration,
    totalPayment: principal + totalAdministration,
  };
}
